/**
 * The two CCJ tolerances the funding engine knows, as the analysis and import
 * endpoints name them. `none` is what the funding batch collection applies to
 * Sentinel Reporting (where ViewThru clients land); `maxFour` is the FairClaim
 * / FFJ tolerance, under which five or more CCJs is a fail. A voluntary
 * arrangement fails under both.
 */
export type CcjRule = 'none' | 'maxFour'

export const DEFAULT_CCJ_RULE: CcjRule = 'none'

export interface CcjRuleOption {
    key: CcjRule
    label: string
    help: string
}

export const CCJ_RULE_OPTIONS: CcjRuleOption[] = [
    { key: 'none', label: 'No CCJs allowed', help: 'Any CCJ fails the client — the rule the funding batch applies to Sentinel Reporting.' },
    { key: 'maxFour', label: 'Up to 4 CCJs allowed', help: 'Five or more CCJs fails the client — the FairClaim / FFJ tolerance.' },
]

export const isCcjRule = (value: unknown): value is CcjRule =>
    CCJ_RULE_OPTIONS.some((option) => option.key === value)

export const ccjRuleLabel = (rule: CcjRule) =>
    CCJ_RULE_OPTIONS.find((option) => option.key === rule)?.label || rule
